'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiFlowMerge = function TiFlowMerge(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 27v-3.1c0-3.2-2.6-5.8-5.8-5.8-1.4 0-2.5-1.2-2.5-2.5v-2.6c1.9-0.7 3.3-2.5 3.3-4.7 0-2.7-2.2-5-5-5s-5 2.3-5 5c0 2.2 1.4 4 3.3 4.7v2.6c0 1.3-1.1 2.5-2.5 2.5-3.2 0-5.8 2.6-5.8 5.8v3.1c-1.9 0.7-3.3 2.5-3.3 4.7 0 2.7 2.2 5 5 5s5-2.3 5-5c0-2.2-1.4-4-3.4-4.7v-3.1c0-1.4 1.2-2.5 2.5-2.5 1.7 0 3.1-0.7 4.2-1.8 1.1 1.1 2.5 1.8 4.2 1.8 1.3 0 2.5 1.1 2.5 2.5v3.1c-2 0.7-3.4 2.5-3.4 4.7 0 2.7 2.3 5 5 5s5-2.3 5-5c0-2.2-1.4-4-3.3-4.7z m-18.3 6.3c-1 0-1.7-0.7-1.7-1.6s0.7-1.7 1.7-1.7 1.6 0.7 1.6 1.7-0.7 1.6-1.6 1.6z m8.3-26.6c0.9 0 1.7 0.7 1.7 1.6s-0.8 1.7-1.7 1.7-1.7-0.7-1.7-1.7 0.8-1.6 1.7-1.6z m8.3 26.6c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.7 1.6-1.7 1.7 0.7 1.7 1.7-0.7 1.6-1.7 1.6z' })
        )
    );
};

exports.default = TiFlowMerge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/flow-merge.js
// module id = 1892
// module chunks = 0